var prism = /** @class */ (function () {
    function prism() {
    }
    prism.STORE_MODULE_NAME = 'prism';
    return prism;
}());
export { prism };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/prism_admin/lib/prism.cls.ts
// module id = zhGu
// module chunks = 69